import React from "react";
import { Empty } from "antd";

function formatTime(seconds) {
  if (seconds < 60) {
    return `${seconds}s`;
  } else if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (remainingSeconds === 0) {
      return `${minutes}m`;
    } else {
      const decimalMinutes = (seconds / 60).toFixed(1);
      return `${decimalMinutes}m`;
    }
  } else {
    const hours = Math.floor(seconds / 3600);
    const remainingMinutes = Math.floor((seconds % 3600) / 60);

    if (remainingMinutes === 0) {
      return `${hours}h`;
    } else {
      const decimalHours = (seconds / 3600).toFixed(1);
      return `${decimalHours}h`;
    }
  }
}

function TranscriptRecording({ recordingTranscript, livePreview }) {
  console.log(livePreview, '<====livePreview')
  console.log(recordingTranscript, '<====recordingTranscript')

  const shouldShowEmpty = recordingTranscript?.length === 0 && (!livePreview || livePreview.size === 0)
  
  if (shouldShowEmpty) {
    return <Empty description="No transcript available" />;
  }
  
  return (
    <div style={{ height: "100%", overflow: "auto", scrollbarWidth: "thin" }}>
      {/* Live preview section */}
      {livePreview && livePreview.size > 0 && (
        <div style={{ marginBottom: "8px", opacity: 0.7, fontStyle: "italic" }}>
          {Array.from(livePreview.entries()).map(([speaker, text]) => (
            <div key={speaker}>
              <p> (live): </p>
              {text}
            </div>
          ))}
        </div>
      )}

      {/* Final transcript section */}
      {recordingTranscript.map((item, idx) => {
        if (item.type === "paused")
          return (
            <div key={idx} style={{ color: "#f39c12", fontStyle: "italic" }}>
              — [Paused] —
            </div>
          );
        if (item.type === "resumed")
          return (
            <div key={idx} style={{ color: "#27ae60", fontStyle: "italic" }}>
              — [Resumed] —
            </div>
          );
        if (item.type === "recovered") {
          // Parse the recovered transcript to remove spk_ prefixes and format nicely
          const parseRecoveredTranscript = (raw) => {
            if (!raw) return [];
            
            return raw.split('\n')
              .map(line => {
                const cleanedLine = line.trim();
                
                // Match: spk_0 [2.71s-3.18s]: text
                let match = cleanedLine.match(
                  /^spk_(\d+)\s+\[([^\]]+)\]:\s*(.*)$/i
                );
                if (match) {
                  return {
                    timestamp: match[2],
                    text: match[3].trim()
                  };
                }
                
                // Match: 0 [00:00-00:05]: text
                match = cleanedLine.match(
                  /^(\d+)\s+\[([^\]]+)\]:\s*(.*)$/i
                );
                if (match) {
                  return {
                    timestamp: match[2],
                    text: match[3].trim()
                  };
                }
                
                // Match lines without speaker prefix (plain text continuation)
                if (cleanedLine && !cleanedLine.match(/^(spk_)?\d+\s+\[/)) {
                  return {
                    timestamp: null,
                    text: cleanedLine
                  };
                }
                
                return null;
              })
              .filter(Boolean);
          };
          
          const chunks = parseRecoveredTranscript(item.transcript);
          
          return (
            <div key={idx} style={{ 
              backgroundColor: "#f0f9ff", 
              padding: "12px", 
              borderRadius: "8px",
              borderLeft: "4px solid #3b82f6",
              marginBottom: "12px"
            }}>
              <div style={{ 
                color: "#1e40af", 
                fontWeight: "600", 
                marginBottom: "8px",
                fontSize: "14px"
              }}>
                📝 {item.timestamp || "Previous Session"}
              </div>
              
              <div style={{ color: "#374151" }}>
                {chunks.length > 0 ? (
                  chunks.map((chunk, chunkIdx) => (
                    <div key={chunkIdx} style={{ marginBottom: "12px" }}>
                      {chunk.timestamp && (
                        <div style={{ color: "#6b7280", fontSize: "12px", marginBottom: "4px" }}>
                          [{chunk.timestamp}]
                        </div>
                      )}
                      <div>{chunk.text}</div>
                    </div>
                  ))
                ) : (
                  <div style={{ whiteSpace: "pre-wrap" }}>
                    {item.transcript}
                  </div>
                )}
              </div>
            </div>
          );
        }
        if (item.type === "separator")
          return (
            <div key={idx} style={{ 
              color: "#6b7280", 
              fontStyle: "italic",
              textAlign: "center",
              margin: "16px 0",
              padding: "8px",
              borderTop: "2px dashed #d1d5db",
              borderBottom: "2px dashed #d1d5db"
            }}>
              {item.transcript || "--- Session Continued ---"}
            </div>
          );
        return (
          <div key={idx}>
            {/* {item.speaker !== undefined && (
              <strong>
                {item.speaker.toString().startsWith("Speaker")
                  ? item.speaker
                  : `Speaker ${parseInt(item.speaker) + 1}: `}
              </strong>
            )} */}
            {item.start_time !== undefined && item.end_time !== undefined && (
              <div style={{ marginTop: 10 }} className="text-gray-500">
                {`[${formatTime(
                  parseFloat(item.start_time.toFixed(2))
                )} - ${formatTime(parseFloat(item.end_time.toFixed(2)))}]`}
              </div>
            )}
            <p>{item?.transcript}</p>
          </div>
        );
      })}
    </div>
  );
}

export default TranscriptRecording;
